import { useCallback, useMemo } from 'react';

import {
  REDIRECT_URI_KEY_PARAM,
  REFRESH_TOKEN_KEY_PARAM,
  ROUTE_AUTO_LOGIN,
  ROUTE_SCANBAT_PRODUCT,
} from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';

const useCartItem = ({
  disabled,
  discountPriceItem,
  isLoading,
  isSalable,
  lineSubtotal,
  mustSubstitute,
  path,
  price,
  weeeAmount,
  weeeTotalAmount,
}) => {
  const { user, zergRush, refreshToken } = useAuth();

  const valueDiscountPriceItem = useMemo(
    () => (!zergRush ? discountPriceItem : null),
    [discountPriceItem, zergRush],
  );

  const valueWeeeAmount = useMemo(() => (!zergRush ? weeeAmount : null), [
    weeeAmount,
    zergRush,
  ]);

  const valuePrice = useMemo(() => (!zergRush ? price : null), [
    price,
    zergRush,
  ]);

  const valueLineSubtotal = useMemo(() => (!zergRush ? lineSubtotal : null), [
    lineSubtotal,
    zergRush,
  ]);

  const valueWeeeTotalAmount = useMemo(
    () => (!zergRush ? weeeTotalAmount : null),
    [weeeTotalAmount, zergRush],
  );

  const isDisabled = useMemo(() => {
    const blocked = disabled || isLoading;
    const notSalable = mustSubstitute || !isSalable;
    const edit = blocked || !user?.functionality_accesses?.carts;

    return {
      delete: edit,
      disabled: blocked,
      loading: isLoading,
      manage: edit || notSalable,
      notSalable,
    };
  }, [disabled, isLoading, isSalable, mustSubstitute, user]);

  const onClickItem = useCallback(() => {
    if (path) {
      const encodedPath = encodeURIComponent(path);
      const encodedRefreshToken = encodeURIComponent(refreshToken);
      const encodedProductUri = encodeURIComponent(
        `${ROUTE_SCANBAT_PRODUCT}/${encodedPath}`,
      );

      const productAutoLoginUri = `${ROUTE_AUTO_LOGIN}?${REFRESH_TOKEN_KEY_PARAM}=${encodedRefreshToken}&${REDIRECT_URI_KEY_PARAM}=${encodedProductUri}`;
      window.open(productAutoLoginUri, '_blank');
    }
  }, [path, refreshToken]);

  return {
    isDisabled,
    onClickItem,
    valueDiscountPriceItem,
    valueLineSubtotal,
    valuePrice,
    valueWeeeAmount,
    valueWeeeTotalAmount,
  };
};

export default useCartItem;
